import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, FormControl, FormLabel, HStack, Input, Text, Textarea, useToast } from '@chakra-ui/react';
import generateDescService from '../../../api/generateDescService';
import LoadingOverlay from '../../../reusable-components/LoadingOverlay/LoadingOverlay';
import { Form } from 'react-bootstrap';
import { RiAiGenerate } from 'react-icons/ri';
import taxonomyService from '../../../api/taxonomyService';

const GenerateDescription = ({ currentImage, refreshImageData, descriptionPrompt,domain }) => {
    const toast = useToast();
    const [showActions, setShowActions] = useState(false);
    const [description, setDescription] = useState([]);
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    // const [taxnonmies, setTaxnonmies] = useState([]);
    const [title, setTitle] = useState("");
    const description_prompts = domain?.description_prompts || []; // 👈 safely extract prompts

    const [inputs, setInputs] = useState({
        fabric: '',
        lining: '',
        // occasion_suitability: '',
        brandName: '',
        // embellishments: ''
    });
    useEffect(() => {
        setIsFormValid(Object.values(inputs).every(value => value.trim() !== ""));
    }, [inputs])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs({ ...inputs, [name]: value });
    };
    useEffect(() => {
        if (currentImage.id) {
            setInputs({
                fabric: currentImage.fabric ? currentImage.fabric : "",
                lining: currentImage.lining ? currentImage.lining : "",
                // occasion_suitability: currentImage.occasion_suitability ? currentImage.occasion_suitability : "",
                brandName: currentImage.brandName ? currentImage.brandName : "",
                // embellishments: currentImage.embellishments ? currentImage.embellishments : ""
            });
        }
            setTitle(currentImage.image_title ? currentImage.image_title : "");
            if (Array.isArray(currentImage.image_description)) {
                setDescription(currentImage.image_description);
            } else if (typeof currentImage.image_description === "string") {
                setDescription([{ default: currentImage.image_description }]); // Convert string to array format
            } else {
                setDescription([]);
            }
    }, [currentImage])

    const generateDescription = async (key) => {
        const payload = {
            comp_id: localStorage.getItem('comp_id'),
            image_id: parseInt(currentImage.id),
            email: localStorage.getItem('email'),
            input_fields:{
                fabric: inputs.fabric,
                lining: inputs.lining,
                // occasion_suitability: inputs.occasion_suitability,
                brandName: inputs.brandName,
                // embellishments: inputs.embellishments
            },
            prompt: key,
            mode:"description"
        }
        try {
            setLoadingOverlay(true);
            const res = await generateDescService.generateDescriptionAndTitle(payload);
            setDescription(prev => {
                const newEntry = { [key]: String(res.data.content) };
                const index = prev.findIndex(item => Object.keys(item)[0] === key);

                let updatedDescription;
                if (index !== -1) {
                    updatedDescription = [...prev];
                    updatedDescription[index] = newEntry;
                } else {
                    updatedDescription = [...prev, newEntry];
                }
                return updatedDescription;
            });
        } catch (err) {
            console.log(err);
            toast({
                title: err?.response?.data?.detail || "Failed to generate description",
                position: "top",
                status: "error",
                duration: 3000,
                variant: "left-accent",
                isClosable: true,
            });
        } finally {
            setLoadingOverlay(false);
        }
    };

    const generateTitle = async () => {
        const payload = {
            comp_id: localStorage.getItem('comp_id'),
            image_id: parseInt(currentImage.id),
            email: localStorage.getItem('email'),
            input_fields:{
                fabric: inputs.fabric,
                lining: inputs.lining,
                // occasion_suitability: inputs.occasion_suitability,
                brandName: inputs.brandName,
                // embellishments: inputs.embellishments
            },
            mode:"title"

        };
        try {
            setLoadingOverlay(true);
            const res = await generateDescService.generateDescriptionAndTitle(payload);
            setTitle(res.data.content);
        } catch (err) {
            console.log(err);
            toast({
                title: err?.response?.data?.detail || "Failed to generate title",
                position: "top",
                status: "error",
                duration: 3000,
                variant: "left-accent",
                isClosable: true,
            });
        } finally {
            setLoadingOverlay(false);
        }
    };


    const handleSave = async (e) => {
        e.preventDefault();
        setLoadingOverlay(true)
        const payload = {
            comp_id: localStorage.getItem('comp_id'),
            image_id: parseInt(currentImage.id),
            fabric: inputs.fabric,
            lining: inputs.lining,
            // occasion_suitability: inputs.occasion_suitability,
            brandName: inputs.brandName,
            // embellishments: inputs.embellishments,
        }

        if (
            Array.isArray(description) &&
            description.some(desc => Object.values(desc).some(value => value.trim() !== ""))
        ) {
            payload.generated_description = description.filter(desc =>
                Object.values(desc).some(value => value.trim() !== "")
            );
        }


        if (title?.trim()) {
            payload.generated_title = title;
        }
        try {
            const res = await generateDescService.saveDescription(payload);
            refreshImageData();
        } catch (e) {
            console.log(e);
        } finally {
            setLoadingOverlay(false);
        }
    }

    const handleCancel = () => {
        // setInputs({ fabric: "", lining: "", occasion_suitability: "", brandName: "",embellishments:"" });
        setInputs({ fabric: "", lining: "", brandName: ""});
        setTitle("");
        setDescription([]);
    }
    const handleDescriptionChange = (key, value) => {
        setDescription(prev => {
            // Create a new object
            const newEntry = { [key]: value };

            // Check if key already exists
            const index = prev.findIndex(item => Object.keys(item)[0] === key);

            if (index !== -1) {
                // If key exists, update it
                const updatedDescription = [...prev];
                updatedDescription[index] = newEntry;
                return updatedDescription;
            } else {
                // If key doesn't exist, add a new object
                return [...prev, newEntry];
            }
        });
    };


    return (
        <>
            <Box as="form" >
                <FormControl isRequired>
                    <Flex align="center" mb={4} >
                        <FormLabel w="18%" fontWeight={"400"} lineHeight={"18px"} fontSize="12px">Fabric</FormLabel>
                        <Form.Control as="textarea" rows={1} type="text" name="fabric" value={inputs.fabric} onChange={handleChange} placeholder="Enter Fabric" />
                    </Flex>
                </FormControl>
                <FormControl isRequired>
                    <Flex align="center" mb={4}>
                        <FormLabel w="18%" fontWeight={"400"} lineHeight={"18px"} fontSize="12px">Lining/Inner</FormLabel>
                        <Form.Control as="textarea" rows={1} type="text" name="lining" value={inputs.lining} onChange={handleChange} placeholder="Enter Lining/Inner" />
                    </Flex>
                </FormControl>
                {/* <FormControl isRequired>
                    <Flex align="center" mb={4}>
                        <FormLabel w="18%" fontWeight={"400"} lineHeight={"18px"} fontSize="12px">Occasion Suitability</FormLabel>
                        <Form.Control as="textarea" type="text" rows={1} name="occasion_suitability" value={inputs.occasion_suitability} onChange={handleChange} placeholder="Enter Occasion Suitability" />
                    </Flex>
                </FormControl> */}
                <FormControl isRequired>
                    <Flex align="center" mb={4}>
                        <FormLabel w="18%" fontWeight={"400"} lineHeight={"18px"} fontSize="12px">Brand Name</FormLabel>
                        <Form.Control as="textarea" flex="1" rows={1} type="text" name="brandName" value={inputs.brandName} onChange={handleChange} placeholder="Enter Brand Name" />
                    </Flex>
                </FormControl>
                {/* <FormControl isRequired>
                    <Flex align="center" mb={4}>
                        <FormLabel w="18%" fontWeight={"400"} lineHeight={"18px"} fontSize="12px">Embellishments/patten/Print & Pattern type</FormLabel>
                        <Form.Control as="textarea" flex="1" rows={1} type="text" name="embellishments" value={inputs.embellishments} onChange={handleChange} placeholder="Enter Embellishments Name" />
                    </Flex>
                </FormControl> */}
                <hr />
                <Box as="form" >
                    <Flex align="center" mb={4} gap={2} >
                        <FormLabel w="12%" fontWeight={"400"} lineHeight={"18px"} fontSize="12px" mt={1}>Title</FormLabel>
                        {isFormValid ? (
                            <RiAiGenerate title="Generate Title" size={21} color="#FF0087" style={{ marginRight: "8px", cursor: "pointer" }} onClick={generateTitle} />
                        ) : (
                            <RiAiGenerate title="Generate Title" size={21} color="#D3D3D3"
                                style={{ marginRight: "8px", cursor: "not-allowed", pointerEvents: "none" }}
                            />
                        )}
                        <Form.Control as="textarea" rows={1} type="text" name="title" value={title} onChange={(e) => setTitle(e.target.value)} />
                    </Flex>
                </Box>
                <hr />
            </Box>
            {description_prompts.map((key) => (
                <Box as="form" key={key} mb={4} >
                    <Flex mb={4} gap={2} >
                        <FormLabel fontWeight={"400"} lineHeight={"18px"} fontSize="12px" mt={1} w="12%">{key} Description</FormLabel>
                        {isFormValid ? (
                            <RiAiGenerate title="Generate Title" size={21} color="#FF0087" style={{ marginRight: "8px", cursor: "pointer",marginTop:"2px" }} onClick={() => generateDescription(key)} />
                        ) : (
                            <RiAiGenerate title="Generate Title" size={21} color="#D3D3D3"
                                style={{ marginRight: "8px", cursor: "not-allowed", pointerEvents: "none",marginTop:"2px" }}
                            />
                        )}
                        <Form.Control as="textarea" rows={3}
                            value={description.find(item => Object.keys(item)[0] === key)?.[key] || ""}
                            onChange={(e) => handleDescriptionChange(key, e.target.value)}
                            size="sm"
                            border="1px solid #3182CE"
                            _focus={{ borderColor: "blue.500" }}
                        />
                    </Flex>
                </Box>
            ))}
            {isFormValid &&
                <Flex justify={"center"}>
                    <HStack mt={4} spacing={4}>
                        <Button colorScheme="green" size="sm" onClick={handleSave}>
                            Save
                        </Button>
                        <Button colorScheme="gray" size="sm" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </HStack>
                </Flex>}
                {loadingOverlay && <LoadingOverlay message={"Loading"} />}
            </>

    );
}

export default GenerateDescription;
